import React, { useEffect, useState, Fragment } from 'react';
import NavList from './NavList';
import SidebarMinimizer from '../SidebarMinimizer/SidebarMinimizer';
import menues from '../Menues';
import { Nav } from 'reactstrap';

import './Sidebar.css';


const FooterSideBar = ({ collapsed }) => {

    let version = null
    try {
        version = VERSION
    } catch (error) { }

    return (
        <Fragment>
            <div className="author-brand mx-auto">
                <a href="http://paradigma.com.ar">Paradigma del Sur S.A.</a>
                &copy; {new Date().getFullYear()}
            </div>
            {
                version &&
                <div className="text-center"><small>{collapsed ? `${version}` : `Versión ${version}`}</small></div>
            }
        </Fragment>
    );
}

const Sidebar = (props) => {

    const [collapsed, setCollapsed] = useState(false);
    const [list, setList] = useState([]);

    useEffect(() => {
        if (props.menu && props.menu.length > 0) {
            setList(props.menu)
        }
    }, [props.menu]);

    return (
        <div className="sidebar">
            <nav className="sidebar-nav">
                <Nav>
                    <NavList
                        items={list ? list : []}
                        path={props.location.pathname}
                    />
                </Nav>
            </nav>
            <SidebarMinimizer
                onSidebarMinimize={setCollapsed}
            />
            <FooterSideBar collapsed={collapsed} />
        </div>
    );

}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js